import React, { useMemo } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import FormContext from "./FormContext";

const FormGroup = React.forwardRef(
  ({ controlId, className, children, ...props }, ref) => {
    const context = useMemo(() => ({ controlId }), [controlId]);
    const classes = classNames("form-group", className);

    return (
      <FormContext.Provider value={context}>
        <div {...props} ref={ref} className={classes}>
          {children}
        </div>
      </FormContext.Provider>
    );
  }
);

FormGroup.propTypes = {
  controlId: PropTypes.string,
  className: PropTypes.string
};

export default FormGroup;
